import React from 'react';
import { css } from '@emotion/react';
import { themeOld } from 'styles/theme';

export enum TooltipDirection {
	TOP,
	LEFT,
	RIGHT,
	BOTTOM,
}

export const Tooltip = ({
	children,
	content,
	direction = TooltipDirection.RIGHT,
}: {
	children?: any;
	content: any;
	direction?: TooltipDirection;
}) => {
	return (
		<div
			css={css`
				position: relative;
				z-index: 9100;

				.tooltip-wrapper {
					position: absolute;
					visibility: hidden;
					opacity: 0;
					transition: all 0.2s ease-in-out;

					${direction === TooltipDirection.LEFT &&
					css`
						transform: translate(0, -50%) scale(0.8);
						left: auto;
						top: 50%;
						right: 100%;
						bottom: auto;
					`}

					${direction === TooltipDirection.RIGHT &&
					css`
						transform: translate(0, -50%) scale(0.8);
						right: auto;
						top: 50%;
						left: 100%;
						bottom: auto;
					`}

					${direction === TooltipDirection.BOTTOM &&
					css`
						transform: translate(-50%, 0) scale(0.8);
						top: 100%;
						left: 50%;
						right: auto;
					`}

					${direction === TooltipDirection.TOP &&
					css`
						transform: translate(-50%, 0) scale(0.8);
						bottom: 100%;
						left: 50%;
						right: auto;
					`}
				}

				&:hover {
					.tooltip-wrapper {
						visibility: visible;
						opacity: 1;
						transition: all 0.16s ease-in-out;

						${direction === TooltipDirection.LEFT &&
						css`
							transform: translate(-8px, -50%) scale(1);
						`}

						${direction === TooltipDirection.RIGHT &&
						css`
							transform: translate(8px, -50%) scale(1);
						`}

						${direction === TooltipDirection.BOTTOM &&
						css`
							transform: translate(-50%, 8px) scale(1);
						`}

						${direction === TooltipDirection.TOP &&
						css`
							transform: translate(-50%, -8px) scale(1);
						`}
					}
				}
			`}
		>
			<div className="tooltip-wrapper">
				<div
					css={css`
						background: ${themeOld.COLOR_DARK_GREEN_DARKEN_6};
						border-radius: 4px;
						color: #fff;
						font-size: 12px;
						padding: 4px 8px;
						font-weight: normal;
						white-space: nowrap;
					`}
				>
					{content}
				</div>
			</div>
			{children}
		</div>
	);
};
